import React from "react";
import { ConnectIcon } from "~/assets/svg/MathIcon";
import { useTranslation } from "react-i18next";
import DropdownTemplate, {
	DropDownItem,
} from "~/common/components/DropdownPortal/DropdownTemplate";

const MemberList = ({
	teamMemberList,
	handleActive,
	handleDelete,
	setResendMailModal,
	setResendMember,
}) => {
	const { t } = useTranslation();
	const TRANS_STATUS = {
		대기: t("pages.myPage.admin.TeamPage.standBy"),
		정상: t("pages.myPage.admin.TeamPage.normal"),
	};
	return (
		<div className="c__card">
			<div className="invite-table">
				<ul className="thead">
					<li className="team-num">No</li>
					<li className="team-name">
						{t("pages.myPage.admin.TeamPage.invite-table.teamName")}
					</li>
					<li className="team-mail">
						{t("pages.myPage.admin.TeamPage.invite-table.teamEmail")}
					</li>
					<li className="team-role">
						{t("pages.myPage.admin.TeamPage.invite-table.teamRole")}
					</li>
					<li className="connect-chk" />
					<li className="team-date">
						{t("pages.myPage.admin.TeamPage.invite-table.teamDate")}
					</li>
					<li className="team-active">
						{t("pages.myPage.admin.TeamPage.invite-table.teamActive")}
					</li>
					<li className="dropdown-wrap" />
				</ul>

				{teamMemberList.map((member, index) => (
					<ul className="tr" key={index}>
						<li className="td team-num">{index + 1}</li>
						<li className="td team-name">{member.name}</li>
						<li className="td team-mail">{member.id}</li>
						<li className="td team-role">
							{member.role === "admin"
								? t("pages.myPage.userType.admin")
								: t("pages.myPage.userType.member")}
						</li>
						<li className="td connect-chk">
							{member.status === "정상" && <ConnectIcon />}
						</li>
						<li className="td team-date">{member.regDate}</li>
						<li className={`td team-active ${member.status === "정상" && "active"}`}>
							{TRANS_STATUS[member.status]}
							{member.role !== "admin" && (
								<DropdownTemplate target={member.idx} vertical>
									<DropDownItem
										onClick={() => {
											setResendMailModal(true);
											setResendMember(member);
										}}
									>
										{t("common.commonWord.button.mail")}
									</DropDownItem>
									<DropDownItem onClick={() => handleActive(member.idx)}>
										{TRANS_STATUS[member.status] === "정상"
											? t("common.commonWord.button.inactive")
											: t("common.commonWord.button.active")}
									</DropDownItem>
									<DropDownItem onClick={() => handleDelete(member.idx)}>
										{t("common.commonWord.button.delete")}
									</DropDownItem>
								</DropdownTemplate>
							)}
						</li>
					</ul>
				))}
			</div>
		</div>
	);
};

export default MemberList;
